import React, { useEffect, useState } from "react";
import {
  createAssessmentsAPIEndpoint,
  EndPoints as EndPointsAssessment,
} from "../../../services/AssessmentAPI";
import {
  createLessonsAPIEndpoint,
  EndPoints,
} from "../../../services/LessonAPI";
import {
  Box,
  Button,
  Pagination,
  PaginationItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ExamDetailsDialog from "../components/Exam/ExamDetailsDialog";
import AddExamDialog from "../components/Exam/AddExamDialog";
import AssessmentStatusToggle from "../components/General/AssessmentStatusToggle";
import {
  createGeneralAPIEndpoint,
  EducationStageEndPoints,
} from "../../../services/General";
import { toUtcISOString } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Exam() {
  const [Exams, setExams] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [educationStages, setEducationStages] = useState([]);
  const navigate = useNavigate();
  const fetchExams = (page, pageSize, search) => {
    createAssessmentsAPIEndpoint(EndPointsAssessment.searchAssessment)
      .fetch({ params: { type: 0, search, page: page + 1, pageSize } })
      .then((response) => {
        setExams(response.data.items || []);
        setTotalCount(response.data.totalCount || 0);
      })
      .catch((error) => {
        console.error("Error fetching Exam data:", error);
        setExams([]);
      });
  };

  const handleViewClick = (Exam) => {
    setSelectedExam(Exam);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    fetchExams(page, pageSize, search);
    setOpenDialog(false);
  };

  const handleExamAdded = (data) => {
    try {
      const payload = {
        ...data,
        type: 0,
        durationMinutes: data.durationMinutes || 0,
        opensAtUtc: toUtcISOString(data.opensAtUtc),
        closesAtUtc: toUtcISOString(data.closesAtUtc),
      };
      createAssessmentsAPIEndpoint(EndPointsAssessment.createAssessment)
        .postWithToken(payload)
        .then((res) => {
          setExams((prevExams) => [...prevExams, data]);
        })
        .catch((err) => console.log(err));
    } catch {}
    setOpenAddDialog(false);
    fetchExams(page, pageSize, search);
  };
  const handleResultsClick = (assessment) => {
    navigate(`/assessments/${assessment.id}/results`);
  };
  useEffect(() => {
    createGeneralAPIEndpoint(EducationStageEndPoints.all)
      .fetch()
      .then((res) => {
        setEducationStages(res.data || []);
      })
      .catch((err) => {
        console.error("Failed to fetch education stages:", err);
      });
    fetchExams(page, pageSize, search);
  }, [page, pageSize, search, openDialog]);

  return (
    <section className="dashboard-section">
      <div className="table-wrapper">
        <TableContainer
          component={Paper}
          sx={{ margin: "2rem auto" }}
          className="table-container"
        >
          <Box className="table-box">
            <TextField
              label="Search"
              variant="standard"
              size="large"
              value={search}
              onChange={(e) => {
                setPage(0);
                setSearch(e.target.value);
              }}
              className="search-field"
            />
            <Button
              variant="contained"
              className="btn-add-record"
              onClick={() => setOpenAddDialog(true)}
            >
              Add New Exam
            </Button>
          </Box>
          <div className="table-title">Exams Data</div>
          <Table className="table">
            <TableHead>
              <TableRow>
                <TableCell className="table-header">
                  <b>Title</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Center</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Status</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Actions</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(Exams) && Exams.length !== 0 ? (
                Exams.map((Exam) => (
                  <TableRow key={Exam.id} className="table-row">
                    <TableCell className="table-cell">
                      {Exam.assessmentTitle || "N/A"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {Exam.centerName || "N/A"}
                    </TableCell>
                    <TableCell className={`table-cell status-cell ${Exam.status === 'Active' ? 'active' : 'inactive'}`}>
                      {Exam.status}
                    </TableCell>
                    <TableCell className="table-cell action-cell">
                      <Button
                        className="btn-view"
                        onClick={() => handleViewClick(Exam)}
                      >
                        View
                      </Button>
                      <Button
                        className="btn-results"
                        onClick={() => handleResultsClick(Exam)}
                      >
                        Results
                      </Button>
                      <AssessmentStatusToggle
                        assessment={Exam}
                        fetchAssessments={fetchExams}
                        page={page}
                        pageSize={pageSize}
                        search={search}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} className="table-cell">
                    No Exams found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Pagination
            className="pagination"
            page={page + 1}
            count={Math.ceil(totalCount / pageSize)}
            onChange={(event, newPage) => setPage(newPage - 1)}
            renderItem={(item) => <PaginationItem component="div" {...item} />}
          />
          <ExamDetailsDialog
            open={openDialog}
            onClose={handleCloseDialog}
            selectedExam={selectedExam}
          />
          <AddExamDialog
            open={openAddDialog}
            onClose={() => setOpenAddDialog(false)}
            onSubmit={handleExamAdded}
            educationStages={educationStages}
          />
        </TableContainer>
      </div>
    </section>
  );
}

export default Exam;
